// This file is generated by a script. Do not edit this file directly.
import React from "react";
import { getInitials } from "../../common/utils";
import { Avatar } from "../Avatar/Avatar";
import { UserWithCompanyAvatar } from "../Avatar/UserWithCompanyAvatar";
import { Chip } from "../Chip/Chip";
export function SelectedValueChip(props) {
  var _option$avatarSrc, _option$label$charAt$, _option$label, _option$avatarFallbac, _option$label2, _option$avatarSrc2, _option$avatarFallbac2, _option$label3, _option$companyName, _option$companyAvatar, _option$companyAvatar2, _option$label4;
  var option = props.data,
    selectProps = props.selectProps,
    useNewColors = props.useNewColors;
  var onChange = selectProps.onChange,
    selectValue = selectProps.value;
  var handleRemove = function handleRemove() {
    if (Array.isArray(selectValue)) {
      var newSelectValue = selectValue ? selectValue.filter(function (_ref) {
        var value = _ref.value;
        return !(value === option.value);
      }) : [];
      onChange(newSelectValue, {
        action: 'remove-value',
        removedValue: option
      });
    }
  };
  return /*#__PURE__*/React.createElement(Chip, {
    className: "!cop-rounded cop-border cop-border-solid cop-px-2 cop-py-[5px]",
    variant: "outlined",
    onClose: handleRemove,
    prefixIcon: option.type === 'company' ? /*#__PURE__*/React.createElement(Avatar, {
      src: (_option$avatarSrc = option.avatarSrc) !== null && _option$avatarSrc !== void 0 ? _option$avatarSrc : '',
      text: (_option$label$charAt$ = (_option$label = option.label) === null || _option$label === void 0 ? void 0 : _option$label.charAt(0).toLocaleUpperCase()) !== null && _option$label$charAt$ !== void 0 ? _option$label$charAt$ : '',
      fallbackColor: (_option$avatarFallbac = option.avatarFallbackColor) !== null && _option$avatarFallbac !== void 0 ? _option$avatarFallbac : '',
      size: "sm",
      variant: "rounded",
      alt: (_option$label2 = option.label) !== null && _option$label2 !== void 0 ? _option$label2 : '',
      useNewColors: useNewColors
    }) : /*#__PURE__*/React.createElement(UserWithCompanyAvatar, {
      size: "sm",
      avatarSrc: (_option$avatarSrc2 = option.avatarSrc) !== null && _option$avatarSrc2 !== void 0 ? _option$avatarSrc2 : '',
      fallbackColor: (_option$avatarFallbac2 = option.avatarFallbackColor) !== null && _option$avatarFallbac2 !== void 0 ? _option$avatarFallbac2 : '',
      text: getInitials((_option$label3 = option.label) !== null && _option$label3 !== void 0 ? _option$label3 : '', true),
      companyText: getInitials((_option$companyName = option.companyName) !== null && _option$companyName !== void 0 ? _option$companyName : ''),
      companyAvatarSrc: (_option$companyAvatar = option.companyAvatarSrc) !== null && _option$companyAvatar !== void 0 ? _option$companyAvatar : '',
      companyAvatarFallbackColor: (_option$companyAvatar2 = option.companyAvatarFallbackColor) !== null && _option$companyAvatar2 !== void 0 ? _option$companyAvatar2 : '',
      useNewColors: useNewColors
    }),
    label: (_option$label4 = option.label) !== null && _option$label4 !== void 0 ? _option$label4 : ''
  });
}
